import { render, staticRenderFns } from "./NoNegativeEmotionPopUp.vue?vue&type=template&id=36b307ac&scoped=true&"
import script from "./NoNegativeEmotionPopUp.vue?vue&type=script&lang=js&"
export * from "./NoNegativeEmotionPopUp.vue?vue&type=script&lang=js&"
import style0 from "./NoNegativeEmotionPopUp.vue?vue&type=style&index=0&id=36b307ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b307ac",
  null
  
)

export default component.exports